import { useEffect, useState } from 'react';
function useScreen() {
    var getScreen = function () {
        if (typeof window !== 'undefined' && window.screen) {
            return window.screen;
        }
        return undefined;
    };
    var _a = useState(getScreen()), screen = _a[0], setScreen = _a[1];
    useEffect(function () {
        function handleResize() {
            setScreen(getScreen());
        }
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return screen;
}
export default useScreen;
//# sourceMappingURL=useScreen.js.map